import {HStack, Link } from '@chakra-ui/react';
import { LogoIcon } from '../../icons/LogoIcon';

const Header = () => {
  return (
    <HStack
      top={0}
      zIndex={1000}
      bgColor="primary.1000"
      py="45px"
      px="10%"
      h="10vh"
      w="full"
      borderBottom="0.5px solid"
      borderColor="primary.800"
      justifyContent="flex-end"
      alignItems="center"
      gap="20px"
    >
      <Link href="/" style={{ marginRight: "auto" }}>
        <LogoIcon h={24} w={24} />
      </Link>
    </HStack>
  );
};

export default Header;
